module.exports = __webpack_public_path__ + "assets/img/404.8c4fccaf.gif";